import {
  BaseSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../../shared/components/select/BaseSelect";

const OptionsDropdown = ({ value, onValueChange, items }) => {
  return (
    <BaseSelect value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {items &&
          items.map((item, index) => (
            <SelectItem key={`item_${index}_${item.code}`} value={item.code}>
              {item.name}
            </SelectItem>
          ))}
      </SelectContent>
    </BaseSelect>
  );
};

export default OptionsDropdown;
